module.exports = __webpack_public_path__ + "7f9e8e41f46eb1ad1d4e629e5de583b0.woff";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/GT-Walsheim-Pro-Thin.woff
// module id = 1245
// module chunks = 0